import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { NomineeComponent } from './dashboard/nominee.component';
import { FinalComponent } from './final/final.component';
import { CategoryComponent } from './dashboard/category.component';

// const appRoutes: Routes = [
//   {
//     path: 'home',
//     component: HomeComponent
//   },
//   { path: '', redirectTo: '/home', pathMatch: 'full' },
//   { path: '**', redirectTo: '/home' }
// ];

const appRoutes: Routes = [
  {
    path: 'home',
    component: HomeComponent
  },
  {
    path: 'finish',
    component: FinalComponent
  },
  {
    path: 'dashboard',
    component: DashboardComponent
  },
  {
    path: 'dashboard/:id',
    component: DashboardComponent,
    children: [
      {
        path: '',
        component: CategoryComponent
      }
    ]
  },
  {
    path: 'dashboard/:id/:cat',
    component: DashboardComponent,
    children: [
      {
        path: '',
        component: NomineeComponent
      }
    ]
  },
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: '**', redirectTo: '/home' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(
      appRoutes,
      {
        enableTracing: false // <-- debugging purposes only
        // preloadingStrategy: SelectivePreloadingStrategy,

      }
    )
  ],
  exports: [
    RouterModule
  ],
  providers: [
    // CanDeactivateGuard,
    // SelectivePreloadingStrategy
  ]
})
export class AppRoutingModule {

  constructor() {
    this.testfunc();
  }

  testfunc() {
    //console.log('routers called');
  }
}
